// extracted by mini-css-extract-plugin
export var GiftsNotification = "index-module--GiftsNotification--98d98";
export var NoName = "index-module--NoName--9cc2c";
export var RTL = "index-module--RTL--49d8c";
export var UserInitials = "index-module--UserInitials--2db8e";
export var avatar = "index-module--avatar--d8108";